<!-- 
  Copyright (c) 2026 Reymel Mislang
  Mindoro State University (MINSU) - Calapan Campus, Philippines
 -->

<template>
  <transition name="fade">
    <div class="modal-overlay" @click="$emit('close')">
      <div class="modal" @click.stop>
        <div class="modal-icon">
          <i class="fas fa-code"></i>
        </div>
        <!-- Title row (+ close on phones, like the other popups) -->
        <div class="modal-head">
          <h3 class="modal-title">Coming Soon</h3>
          <button type="button" class="modal-x" aria-label="Close" @click="$emit('close')">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <p class="modal-text">{{ message }}</p>
        <button @click="$emit('close')" class="modal-close-button">Got it</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ProjectModal',
  props: {
    message: {
      type: String,
      required: true
    }
  },
  emits: ['close']
}
</script>

<style scoped>

@media (max-width: 768px) {
  .modal-overlay {
    z-index: 99999 !important;
  }

  .modal,
  .links-modal,
  .project-links-modal {
    position: relative;
    z-index: 100000 !important;
  }

  .fab-container,
  .floating-button,
  .floating-actions,
  .quick-fab,
  .fab {
    z-index: 1000 !important;
  }
}

@media (max-width: 768px) {
  body:has(.modal-overlay) .fab-container,
  body:has(.modal-overlay) .floating-button,
  body:has(.modal-overlay) .floating-actions,
  body:has(.modal-overlay) .quick-fab,
  body:has(.mobile-modal-overlay) .fab-container,
  body:has(.mobile-modal-overlay) .floating-button,
  body:has(.mobile-modal-overlay) .floating-actions,
  body:has(.mobile-modal-overlay) .quick-fab {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: var(--surface);
  padding: 2rem;
  border-radius: var(--radius);
  text-align: center;
  max-width: 1000px;
  width: 95%;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  position: relative;
}

.modal-icon {
  font-size: 3rem;
  color: var(--accent);
  margin-bottom: 1rem;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 1rem;
}

.modal-text {
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.modal-close-button {
  background: var(--accent);
  color: var(--bg);
  border: none;
  padding: 0.9rem 1.8rem;
  border-radius: var(--radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.15s ease;
  min-height: 44px;
  width: 100%;
}

.modal-close-button:active {
  transform: scale(0.98);
  background: var(--accent-hover);
}

/* Animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.modal-x {
  display: none;
}

/* Phones: same layout as the Certifications / Dean's List / Project Links popups */
@media (max-width: 768px) {
  .modal {
    display: flex;
    flex-direction: column;
    padding: 1.25rem 1.1rem 1.1rem;
    text-align: left;
  }

  .modal-icon {
    display: none;
  }

  .modal-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 34px;
    margin: 0 0 0.85rem;
    padding: 0 0 0.75rem;
    border-bottom: 1px solid var(--border);
  }

  .modal-title {
    margin: 0;
    color: var(--text);
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .modal-x {
    display: grid;
    place-items: center;
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    padding: 0;
    border: 1px solid var(--border);
    border-radius: 50%;
    background: var(--surface-soft);
    color: var(--text);
    cursor: pointer;
  }

  .modal-text {
    margin: 0 0 1rem;
    color: var(--text-secondary);
    font-size: 0.85rem;
    line-height: 1.5;
  }

  .modal-close-button {
    width: 100%;
    margin-top: auto;
  }
}
</style>
